import { render, staticRenderFns } from "./ToolbarCriticism.vue?vue&type=template&id=5bcd2690"
import script from "./ToolbarCriticism.vue?vue&type=script&lang=js"
export * from "./ToolbarCriticism.vue?vue&type=script&lang=js"
import style0 from "./ToolbarCriticism.vue?vue&type=style&index=0&id=5bcd2690&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports